(function(){
"use strict";
function initCountdown(root){
var el = root.querySelector("[data-os-countdown]");
if(!el) return;
var durationMinutes = parseInt(el.getAttribute("data-duration-minutes"), 10) || 1427;
var end = Date.now() + durationMinutes * 60000;
function tick(){
var rem = Math.max(0, end - Date.now());
var totS = Math.floor(rem / 1000);
var h = Math.floor(totS / 3600), m = Math.floor((totS % 3600) / 60), s = totS % 60;
function pad(n){ return String(n).padStart(2, "0"); }
el.textContent = pad(h) + "H " + pad(m) + "M " + pad(s) + "S";
if(rem <= 0) clearInterval(timer);
}
tick();
var timer = setInterval(tick, 1000);
}
function initStickyAtc(root){
var bar = root.querySelector("[data-os-sticky-atc]");
if(!bar) return;
var threshold = parseInt(bar.getAttribute("data-show-after"), 10) || 700;
function onScroll(){
if(window.scrollY > threshold){ bar.classList.add("is-visible"); }
else{ bar.classList.remove("is-visible"); }
}
window.addEventListener("scroll", onScroll, { passive:true });
onScroll();
}
function initFaq(root){
var items = root.querySelectorAll("[data-os-faq-item]");
if(!items.length) return;
items.forEach(function(item){
var btn = item.querySelector("[data-os-faq-toggle]");
if(!btn) return;
btn.addEventListener("click", function(){
var isOpen = item.classList.contains("is-open");
items.forEach(function(i){ i.classList.remove("is-open"); });
if(!isOpen) item.classList.add("is-open");
});
});
}
function initQuantity(root){
root.querySelectorAll("[data-os-qty]").forEach(function(wrap){
var input = wrap.querySelector("input");
var minus = wrap.querySelector("[data-qty-minus]");
var plus  = wrap.querySelector("[data-qty-plus]");
if(!input) return;
function clamp(v){
var min = parseInt(input.min,10) || 1;
var max = parseInt(input.max,10) || 9;
return Math.min(max, Math.max(min, v));
}
if(minus) minus.addEventListener("click", function(){
input.value = clamp((parseInt(input.value,10)||1) - 1);
input.dispatchEvent(new Event("change", { bubbles:true }));
});
if(plus) plus.addEventListener("click", function(){
input.value = clamp((parseInt(input.value,10)||1) + 1);
input.dispatchEvent(new Event("change", { bubbles:true }));
});
});
}
function osMoney(cents){
if(cents == null || isNaN(cents)) return "";
return "€" + (cents/100).toFixed(2).replace(".", ",");
}
function initBuyboxPricing(root){
var buyboxEl = (root.matches && root.matches("[data-os-buybox]")) ? root : root.querySelector("[data-os-buybox]");
if(!buyboxEl) return;
if(buyboxEl.getAttribute("data-os-pricing-bound") === "true") return;
buyboxEl.setAttribute("data-os-pricing-bound", "true");
var hasVariantPairs = buyboxEl.getAttribute("data-has-variant-pairs") === "true";
var bundleWrap = buyboxEl.querySelector("[data-os-bundle-selector]");
var modeWrap = buyboxEl.querySelector("[data-os-mode-toggle]");
var formEl = buyboxEl.querySelector("[data-os-atc-form]") || buyboxEl.querySelector("form");
var bundleCards = bundleWrap ? Array.prototype.slice.call(bundleWrap.querySelectorAll("[data-os-bundle-card]")) : [];
var modeCards = modeWrap ? Array.prototype.slice.call(modeWrap.querySelectorAll("[data-os-mode-card]")) : [];
function setSellingPlan(plan){
var sp = formEl ? formEl.querySelector('[name="selling_plan"]') : null;
if(sp){ sp.value = plan || ""; }
}
function reassertPlan(){
var m = modeCards.filter(function(c){ return c.classList.contains("is-selected"); })[0];
var plan = m ? m.getAttribute("data-selling-plan") : "";
setSellingPlan(plan);
setTimeout(function(){ setSellingPlan(plan); }, 60);
setTimeout(function(){ setSellingPlan(plan); }, 250);
}
function currentMode(){
var checked = modeCards.filter(function(c){ return c.classList.contains("is-selected"); })[0];
return checked ? checked.getAttribute("data-os-mode") : "one";
}
function resolveForCard(card, mode){
var oneId = card.getAttribute("data-onetime-id");
var onePrice = parseInt(card.getAttribute("data-onetime-price"), 10);
var oneCompare = parseInt(card.getAttribute("data-onetime-compare"), 10);
var subPrice = parseInt(card.getAttribute("data-sub-price"), 10);
var aboId = card.getAttribute("data-abo-id");
var hasAbo = !!aboId;
if(mode === "sub" && !isNaN(subPrice)){
return { id: oneId, price: subPrice, compare: oneCompare };
}
if(mode === "sub" && hasVariantPairs && hasAbo){
return {
id: aboId,
price: parseInt(card.getAttribute("data-abo-price"), 10),
compare: parseInt(card.getAttribute("data-abo-compare"), 10)
};
}
return { id: oneId, price: onePrice, compare: oneCompare };
}
function setCardVisualSelected(list, target){
list.forEach(function(c){
c.classList.remove("is-selected");
var dot = c.querySelector(".os-bundle-card__dot");
if(dot) dot.textContent = "";
});
target.classList.add("is-selected");
var dot2 = target.querySelector(".os-bundle-card__dot");
if(dot2) dot2.textContent = "✓";
}
function renderPrices(){
var mode = currentMode();
var selected = bundleCards.filter(function(c){ return c.classList.contains("is-selected"); })[0] || bundleCards[0];
var selectedPrice = null, selectedCompare = null;
bundleCards.forEach(function(card){
var sel = resolveForCard(card, mode);
var nowEl = card.querySelector(".os-bundle-card__price .now");
var cmpEl = card.querySelector(".os-bundle-card__price .compare");
if(nowEl) nowEl.textContent = osMoney(sel.price);
if(cmpEl){
if(sel.compare && sel.compare > sel.price){
cmpEl.textContent = osMoney(sel.compare);
cmpEl.style.display = "";
} else {
cmpEl.style.display = "none";
}
}
var radio = card.querySelector('input[type="radio"][name="id"]');
if(radio) radio.value = sel.id;
if(card === selected){
selectedPrice = sel.price;
selectedCompare = sel.compare;
if(radio) radio.checked = true;
}
});
if(selectedPrice == null) return;
var priceRoot = buyboxEl.querySelector(".os-buybox__price");
if(priceRoot){
var nowEl2 = priceRoot.querySelector(".now");
var cmpEl2 = priceRoot.querySelector(".compare");
var saveEl = priceRoot.querySelector(".save");
if(nowEl2) nowEl2.textContent = osMoney(selectedPrice);
if(selectedCompare && selectedCompare > selectedPrice){
if(cmpEl2){ cmpEl2.textContent = osMoney(selectedCompare); cmpEl2.style.display = ""; }
if(saveEl){
var pct = Math.round((1 - selectedPrice / selectedCompare) * 100);
saveEl.textContent = "−" + pct + "%";
saveEl.style.display = "";
}
} else {
if(cmpEl2) cmpEl2.style.display = "none";
if(saveEl) saveEl.style.display = "none";
}
}
var atcPriceEl = buyboxEl.querySelector("[data-atc-price]");
if(atcPriceEl) atcPriceEl.textContent = osMoney(selectedPrice);
var selForSticky = resolveForCard(selected, mode);
document.querySelectorAll("[data-os-sticky-atc]").forEach(function(bar){
var priceEl = bar.querySelector(".os-sticky-atc__price");
if(priceEl){
var nowSpan = priceEl.querySelector(".now");
var cmpSpan = priceEl.querySelector(".compare");
if(nowSpan){
nowSpan.textContent = osMoney(selForSticky.price);
} else {
priceEl.textContent = osMoney(selForSticky.price);
}
if(cmpSpan){
if(selForSticky.compare && selForSticky.compare > selForSticky.price){
cmpSpan.textContent = osMoney(selForSticky.compare);
cmpSpan.style.display = "";
} else {
cmpSpan.style.display = "none";
}
}
}
var variantInput = bar.querySelector("[data-os-variant-id]");
if(variantInput) variantInput.value = selForSticky.id;
});
}
if(bundleWrap){
bundleWrap.addEventListener("click", function(e){
var card = e.target.closest ? e.target.closest("[data-os-bundle-card]") : null;
if(!card || !bundleWrap.contains(card)) return;
setCardVisualSelected(bundleCards, card);
reassertPlan();
renderPrices();
});
}
if(modeWrap){
modeWrap.addEventListener("click", function(e){
var card = e.target.closest ? e.target.closest("[data-os-mode-card]") : null;
if(!card || !modeWrap.contains(card)) return;
modeCards.forEach(function(c){ c.classList.remove("is-selected"); });
card.classList.add("is-selected");
var radio = card.querySelector('input[type="radio"]');
if(radio) radio.checked = true;
setSellingPlan(card.getAttribute("data-selling-plan"));
reassertPlan();
renderPrices();
});
}
var initMode = modeCards.filter(function(c){ return c.classList.contains("is-selected"); })[0];
if(initMode) setSellingPlan(initMode.getAttribute("data-selling-plan"));
if(bundleCards.length || modeCards.length) renderPrices();
}
function initGallery(root){
var main = root.querySelector("[data-os-gallery-main]");
if(!main) return;
root.querySelectorAll("[data-os-gallery-thumb]").forEach(function(thumb){
thumb.addEventListener("click", function(){
root.querySelectorAll("[data-os-gallery-thumb]").forEach(function(t){ t.classList.remove("is-active"); });
thumb.classList.add("is-active");
var src = thumb.getAttribute("data-full-src");
var img = main.querySelector("img");
if(src && img) img.src = src;
});
});
}
function initAddToCart(root){
root.querySelectorAll("[data-os-atc-form], [data-os-product-form]").forEach(function(form){
if(form.getAttribute("data-os-ajax-bound") === "true") return;
form.setAttribute("data-os-ajax-bound", "true");
form.addEventListener("submit", function(e){
e.preventDefault();
var btn = form.querySelector('[type="submit"]');
var box = (form.closest && form.closest("[data-os-buybox]")) || document.querySelector("[data-os-buybox]");
if(box){
var selMode = box.querySelector("[data-os-mode-card].is-selected");
var spField = form.querySelector('[name="selling_plan"]');
if(selMode && spField){ spField.value = selMode.getAttribute("data-selling-plan") || ""; }
}
var formData = new FormData(form);
if(formData.get("selling_plan") === ""){ formData.delete("selling_plan"); }
if(btn){ btn.disabled = true; btn.classList.add("is-loading"); }
fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + "cart/add.js" : "/cart/add.js", {
method: "POST",
headers: { "Accept": "application/json" },
body: formData
})
.then(function(res){ return res.json(); })
.then(function(data){
if(data.status){
console.error("OneSupps addToCart error:", data.description || data.message);
alert((data.description) || "Der Artikel konnte nicht zum Warenkorb hinzugefügt werden.");
return;
}
document.dispatchEvent(new CustomEvent("os:cart:updated"));
updateCartCount();
if(window.OneSuppsCart){
window.OneSuppsCart.refresh().then(function(){
window.OneSuppsCart.open();
});
}
})
.catch(function(err){ console.error("OneSupps addToCart failed:", err); })
.finally(function(){
if(btn){ btn.disabled = false; btn.classList.remove("is-loading"); }
});
});
});
}
function updateCartCount(){
fetch("/cart.js", { headers: { "Accept": "application/json" } })
.then(function(res){ return res.json(); })
.then(function(cart){
document.querySelectorAll("[data-os-cart-count]").forEach(function(el){
el.textContent = cart.item_count;
});
})
.catch(function(){  });
}
function initSection(root){
initCountdown(root);
initStickyAtc(root);
initFaq(root);
initQuantity(root);
initBuyboxPricing(root);
initGallery(root);
initAddToCart(root);
}
function initAll(){
document.querySelectorAll("[data-os-section]").forEach(initSection);
updateCartCount();
}
document.addEventListener("DOMContentLoaded", initAll);
document.addEventListener("shopify:section:load", function(evt){
var root = evt.target.querySelector ? evt.target.querySelector("[data-os-section]") : null;
if(root) initSection(root);
else if(evt.target.matches && evt.target.matches("[data-os-section]")) initSection(evt.target);
});
})();
